import TEXT_RULES, { getBestRule } from './text-rules';
import { removeEl } from './util';

const HED_AND_DEK_MARGIN = 8;
const WSJ_PRINT_HED_MARGIN = 4;
const SUBDEK_MARGIN = 14;
const WSJ_PRINT_SUBDEK_MARGIN = 7;
const PRINT_LINE = 9.6;

export function preRender(data, options) {
  return data;
}


export function postRender(highchart, options) {
  const R = getRules(options);
  const result = {
    hed: null,
    dek: null,
    subdek: null,
    x: highchart.spacing[3],
    y: highchart.spacing[0],
    width: (options.width - highchart.spacing[3] - highchart.spacing[1]) + 'px'
  };
  if (R.HED) {
    writeHed(options, highchart.renderer, R.HEADINGS.title.text, result);
  }
  if ((R.HED && R.DEK) || (R.HED && R.SUBDEK)) {
    result.y += R.WSJ_PRINT ? WSJ_PRINT_HED_MARGIN : HED_AND_DEK_MARGIN;
    if (options.product === 'wsj' && !options.print) result.y -= 3;
  }
  if (R.DEK) {
    writeDek(options, highchart.renderer, R.HEADINGS.dek.text, result, R);
  }
  if ((R.HED && R.DEK && R.SUBDEK) || (R.DEK && R.SUBDEK)) {
    result.y += R.WSJ_PRINT ? WSJ_PRINT_SUBDEK_MARGIN : SUBDEK_MARGIN;
    if (options.product === 'wsj' && !options.print) result.y += 9;
  }
  if (R.SUBDEK) {
    writeChartLabel(options, highchart.renderer, R.HEADINGS.subdek.text, result, R);
  }
  if (R.WSJ_PRINT) {
    result.y = Math.max(result.y, PRINT_LINE);
  }
  return result;
}


export function renderInvalidated(rendered, options, invalidated) {
  if (__ALL__) {
    if (!rendered.outerInfo.info) {
      return false;
    }
    const R = getRules(options);
    const result = rendered.outerInfo.info.headlines;
    const invalidHed = invalidated.indexOf('headings/title') !== -1;
    const invalidDek = invalidated.indexOf('headings/dek') !== -1 ||
      (R.DEK && invalidHed && !result.hed);

    if ((invalidHed || invalidDek) && !!rendered.outer.spacing) {
      result.y = rendered.outer.spacing[0];

      // If previously there was no HED but now there is, rewrite the DEK to
      // force the face to change from bold to normal.
      const invalidDek2 = R.DEK && invalidHed && !result.hed;

      if (invalidHed) {
        removeEl(result.hed);
        if (R.HED) {
          writeHed(options, rendered.outer.renderer, R.HEADINGS.title.text, result);
        } else {
          result.hed = null;
        }
      } else if (result.hed) {
        result.y = result.hed.bottom;
      }

      if (R.HED && R.DEK) {
        result.y += R.WSJ_PRINT ? WSJ_PRINT_HED_MARGIN : HED_AND_DEK_MARGIN;
      }

      if (invalidDek) {
        removeEl(result.dek);
        if (R.DEK) {
          writeDek(options, rendered.outer.renderer, R.HEADINGS.dek.text, result, R.HED);
        } else {
          result.dek = null;
        }
      } else if (result.dek) {
        if (result.y !== result.dek.y) {
          let delta = result.y - result.dek.y;
          if (result.dek.el) {
            let nowY = +result.dek.el.element.getAttribute('y');
            result.dek.el.element.setAttribute('y', nowY + delta);
          }
          result.dek.y += delta;
          result.dek.bottom += delta;
        }
        result.y = result.dek.bottom;
      }

      rendered.outerInfo.y = result.y;
      if (R.WSJ_PRINT) {
        rendered.outerInfo.y = Math.max(rendered.outerInfo.y, PRINT_LINE);
      }
      return true;
    }
    return false;
  }
}


function getRules(options) {
  const RULE = getBestRule(options.size);
  const HEADINGS = options.headings;
  const HED = HEADINGS.title.text && HEADINGS.title.enabled && RULE.title;
  const DEK = HEADINGS.dek.text && HEADINGS.dek.enabled && RULE.dek;
  const SUBDEK = HEADINGS.subdek.text && HEADINGS.subdek.enabled && RULE.subdek;
  const WSJ_PRINT = options.size === 'print-wsj';
  return { RULE, HEADINGS, HED, DEK, SUBDEK, WSJ_PRINT };
}


function writeHed(options, renderer, text, result) {
  const css = getCss(options, 'hed', result.width);
  let wsjPrint = false;
  if (__WSJ__) {
    if (wsjPrint = options.size === 'print-wsj') {
      result.y = PRINT_LINE * 2;
    }
  }
  let financialnewsFirstLetterJ = false;
  if (__FINANCIALNEWS__) {
    if (text.charAt(0) === "J") {
      financialnewsFirstLetterJ = true;
    }
  }
  let obj = writeText(financialnewsFirstLetterJ, renderer, text, result.x, result.y, css, wsjPrint, 'charts-headline');
  result.hed = {
    x: result.x,
    y: result.y,
    width: result.width,
    offsetY: obj.offsetY,
    bottom: obj.bottom,
    el: obj.el
  };
  result.y = obj.bottom;
}

function writeDek(options, renderer, text, result, rules) {
  let financialnewsFirstLetterJ = false;
  if (__WSJ__) {
    if (!rules.HED && options.size === 'print-wsj') {
      result.y = PRINT_LINE;
    }
  }
  let css = getCss(options, 'dek', result.width);
  let obj = writeText(financialnewsFirstLetterJ, renderer, text, result.x, result.y, css, null, 'charts-dek');
  result.dek = {
    x: result.x,
    y: result.y,
    width: result.width,
    offsetY: obj.offsetY,
    bottom: obj.bottom,
    el: obj.el
  };
  result.y = obj.bottom;
}

function writeChartLabel(options, renderer, text, result, rules) {
  let financialnewsFirstLetterJ = false;
  if (__WSJ__) {
    if (!rules.HED && !rules.DEK && options.size === 'print-wsj') {
      result.y = PRINT_LINE;
    }
  }
  let css = getCss(options, 'subdek', result.width, rules);
  let obj = writeText(financialnewsFirstLetterJ, renderer, text, result.x, result.y, css, null, 'charts-dek');
  result.chartLabel = {
    x: result.x,
    y: result.y,
    width: result.width,
    offsetY: obj.offsetY,
    bottom: obj.bottom,
    el: obj.el
  };
  result.y = obj.bottom;
}

function getCss(options, headline, width, rules) {
  const size = headline === 'hed' ? 'xlarge' : 'large';
  const type = headline === 'dek' ? headline : 'hed';
  const boldSubdek = headline === 'subdek' && (rules.DEK || (!rules.HED && !rules.DEK));
  const subdekSameAsDek = headline === 'subdek' && rules.HED && rules.SUBDEK && !rules.DEK;
  const weight = boldSubdek ? 'bold' : 'normal';
  let fontFamily = options.styles.font.normal;
  let fontWeight = options.styles.weight[weight];
  let color = options.styles.color[type];

  // HED
  if (headline === 'hed') {
    if (options.product === 'financialnews') {
      fontFamily = '"Publico Text","Publico"';
      fontWeight = options.styles.weight.bold;
    } else if (options.product === 'marketwatch') {
      color = '#666F7D';
      fontFamily = options.styles.font.bold;
      fontWeight = options.styles.weight.bold;
    } else if (options.product === 'mansionglobal') {
      fontFamily = '"Chronicle SSm Semi-Bold","Chronicle Text G1 A"';
      fontWeight = options.styles.weight.semibold;
    } else if (options.product === 'heatstreet') {
      fontFamily = options.styles.font.semibold;
      fontWeight = options.styles.weight.semibold;
    }
  }

  let css = options.styles.get(size, {
    fontFamily,
    fontWeight,
    color,
    width,
  });

  if (__WSJ__) {
    if (options.product === 'wsj') {
      const prop = headline === 'hed' ? 'headline' : 'description';
      const colorProp = type === 'dek' ? 'description' : 'headline';
      const printSubdek = options.print && headline === 'subdek';
      css.fontFamily = printSubdek && boldSubdek ? options.styles.headline.fontFamily : options.styles[prop].fontFamily;
      css.color = options.styles[colorProp].color;
      css.fontSize = headline === 'subdek' && !options.print ? '15px' : options.styles[prop].fontSize;
      if (options.size === 'appfeed') {
        css.fontSize = headline === 'subdek' ? '18px' : options.styles[prop].fontSize;
      }
      css.fontWeight = headline === 'subdek' ? css.fontWeight : options.styles[prop].fontWeight;
      css.lineHeight = options.styles[prop].lineHeight;

      if (subdekSameAsDek && headline === 'subdek') {
        css.fontSize = options.styles['description'].fontSize;
        css.lineHeight = options.styles['description'].lineHeight;
        css.fontWeight = options.styles['description'].fontWeight;
        css.color = options.styles['description'].color;
      }
    }
  }
  return css;
}


// Renders a generic block of text (either hed, dek or subdek) and returns the element
// and its bottom y.
function writeText(financialnewsFirstLetterJ, renderer, text, x, y, css, skipOffsetY = false, className = '') {
  const offsetY = skipOffsetY ? 0 : parseInt(css.fontSize, 10);
  if (financialnewsFirstLetterJ) {
    x = 3;
  };
  const el = renderer.text(text)
    .css(css)
    .attr({ x, y: y + offsetY, class: className })
    .add();
  const tspan = el.element.querySelectorAll('tspan');
  const lines = (tspan && tspan.length) ? tspan.length : 1;
  const lineHeight = parseInt(css.lineHeight, 10);
  const bottom = y + offsetY + lineHeight * (lines - 1)
  return { el, offsetY, bottom };
}


// WEBPACK FOOTER //
// ./src/chart/outer/headlines.js